__turbopack_context__.v({
  "introText": "ProductPromotionMessaging-module-scss-module__0Y9VYq__introText",
  "itemAlert": "ProductPromotionMessaging-module-scss-module__0Y9VYq__itemAlert",
  "link": "ProductPromotionMessaging-module-scss-module__0Y9VYq__link",
  "outroText": "ProductPromotionMessaging-module-scss-module__0Y9VYq__outroText",
  "spendMessageItem": "ProductPromotionMessaging-module-scss-module__0Y9VYq__spendMessageItem",
  "unstyledList": "ProductPromotionMessaging-module-scss-module__0Y9VYq__unstyledList",
});
